var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconNewsAgenda = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M46.0006 12.1997H14.5001C12.0148 12.1997 10 14.2144 10 16.6997V48.1998C10 50.6851 12.0148 52.6998 14.5001 52.6998H46.0006C48.486 52.6998 50.5007 50.6851 50.5007 48.1998V16.6997C50.5007 14.2144 48.486 12.1997 46.0006 12.1997Z",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.25 7.69983V16.6998",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.25 7.69983V16.6998",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10 25.6997H50.5007",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.25 34.6998H21.2725",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.25 34.6998H30.2725",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M39.25 34.6998H39.2725",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M21.25 43.6998H21.2725",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M30.25 43.6998H30.2725",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M39.25 43.6998H39.2725",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconNewsAgenda;